import CMSAPI from "../../../../services/api/contentManagmentApi";
import algoliasearch from "algoliasearch/lite";
import Hero from "../../../home/hero/hero.vue";

const { updateFeaturedCollections, getFeaturedCollections, uploadFile } = new CMSAPI();

export default {
  components: {
    Hero,
  },
  data() {
    return {
      algoliaClient: algoliasearch(this.$env.algolia().appId, this.$env.algolia().token, {
        timeouts: {
          connect: this.$utils.constants.ALGOLIA_CONNECT_TIMEOUT,
          read: this.$utils.constants.ALGOLIA_READ_TIMEOUT,
        },
      }),
      featuredCollections: null,
      allCollections: [],
    };
  },
  methods: {
    handleFileUpload,
    submitFeaturedCollections,
  },
  mounted() {
    getFeaturedCollections().then((result) => {
      this.featuredCollections = result?.data;
    });
    const searchIndexCollection = this.algoliaClient.initIndex(this.$env.getOrigin() + "_collections");
    searchIndexCollection.clearCache();
    searchIndexCollection
      .search({
        query: this.query,
        hitsPerPage: 1000,
      })
      .then((response) => {
        this.allCollections = response.hits.map((hit) => ({
          title: hit.title,
          id: hit.id,
        }));
      });
  },
};

function handleFileUpload(i, files) {
  this.$notify.$emit("fire", {
    message: "uploading image..",
    type: "working",
  });
  const formData = new FormData();
  formData.append("file", files[0]);
  uploadFile(formData).then((response) => {
    this.featuredCollections[i].image_url = response.data.url;
    this.$notify.$emit("update", "Image Upload complete..");
    const timeout = 350;
    setTimeout(() => this.$notify.$emit("close", true), timeout);
  });
}

function submitFeaturedCollections() {
  updateFeaturedCollections({
    view_components: this.featuredCollections.map((component, i) => ({
      component_type: "COLLECTION",
      entity_id: component.entity_id,
      ordinal: i + 1,
      attributes: {
        image_url: component.image_url,
        title: component.title,
        homepage_title: component.homepage_title,
      },
    })),
  })
    .then(() => this.$swal("Features Saved"))
    .catch((error) =>
      error.response
        ? this.$swal("Attention", error.response.data.error_message)
        : this.$logger.notify(new Error(error))
    );
}
